<template>
	<div class="  bg-color--dark--1 h-min-100vh" style="overflow: hidden;">
		<b-container>
			<b-navbar type="dark" variant="fade">
				<b-navbar-brand href="/" class="align-right">
					<b-img
						left
						src="/assets/logo.png"
						alt="brand-logo"
						width="80px"
						height="80px"
					></b-img>
				</b-navbar-brand>
			</b-navbar>
		</b-container>

		<div class="svg-shape--top w-100 opacity--05">
			<img src="/assets/img/wave-8.svg" alt="wave" class="svg fill--white" />
		</div>
		<!-- end of whole area svg bg -->
		<div class="svg-shape--top opacity--10">
			<img src="/assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
		</div>
		<section class=" align-items-center ">
			<b-container>
				<h2 class="text-white mt-0  pt-4 mb-6" v-show="routeLogin"><center>{{$t('login.login')}}</center></h2>
				<h2 class="text-white mt-0 pt-6   mb-1" v-show="routeSignUp"><center>{{$t('register.signUp')}}</center></h2>
				<h2 class="text-white mt-0 pt-4   mb-6" v-show="routeOtp"><center>{{$t('register.otp')}}</center></h2>
				<h2 class="text-white mt-0 pt-4   mb-6" v-show="routeForgotPass"><center>{{$t('login.forgoPassLabl')}}</center></h2>
				<b-row align-h="center">
					<b-col xl="6" lg="7" md="8" sm="9" cols="10">
						<div class="form--v5 rounded--10 bg-color--light--1 ">
							<transition name="fade" enter-active-class="animated fadeIn">
								<router-view></router-view>
							</transition>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</section>
	</div>
</template>

<script>
export default {
	computed: {
		routeLogin() {
			if (this.$route.name === "login") {
				return true;
			}
			return false
		},
		routeSignUp() {
			if (this.$route.name === "signUp") {
				return true;
			}
			return false
		},
		routeOtp() {
			if (this.$route.name === "otp") {
				return true;
			}
			return false
		},
		routeForgotPass(){
			if (this.$route.name === "forgatPass") {
				return true;
			}
			return false
		}
	},
};
</script>
